import { SUPER_ADMIN_ROLE } from "~/constants/advisor";
import { useAppStore } from "@/store/app";
import { storeToRefs } from "pinia";

export default defineNuxtPlugin(async () => {
  const { user } = storeToRefs(useAppStore());
  const route = useRoute();
  const publicPrefixes = [
    "/embed",
    "/docs",
    "/client",
    "/login",
    "/logout",
    "/maintenance",
    "/test-links",
    "/forget-password",
    "/reset-password",
    "/developer/login",
  ];
  const isPublicRoute =
    publicPrefixes.some((prefix) => route.path.startsWith(prefix)) ||
    route.name === "advisor-org_id-login";
  if (!user.value && !isPublicRoute) {
    await useNuxtApp().$auth.fetchUser().catch(() => null);
  }

  return {
    provide: {
      isSuperAdmin: computed(() => user.value?.user_type === SUPER_ADMIN_ROLE),
    },
  };
});
